import React from 'react';
import { IModuleMenuItem } from './interfaces';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

export const ModuleMenuItem: React.FC<IModuleMenuItem> = ({
  title,
  subTitle,
  icon,
  active = false,
  onClick,
}): JSX.Element => {
  return (
    <ListItemButton
      onClick={!active && onClick ? onClick : undefined}
      className={active ? 'active' : ''}
      sx={{
        p: 0,
        px: '15px',
        borderRadius: '10px',
        ':not(:last-child)': {
          mb: '10px',
        },
        '&:hover svg, &.active svg': {
          color: 'primary.main',
        },
        '&.active': {
          pointerEvents: active ? 'none' : 'auto',
        },
      }}
      selected={active}
    >
      <ListItemIcon
        sx={{
          minWidth: 'unset',
          mr: '15px',
          svg: {
            fontSize: '25px',
          },
        }}
      >
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={title}
        secondary={subTitle}
        primaryTypographyProps={{
          fontSize: '.95rem',
        }}
      />
    </ListItemButton>
  );
};
